import { combineReducers } from 'redux';
import config from './modules/config';
import ui from './modules/ui';
import form from './modules/form';
import customer from './modules/customer';
import user from './modules/user';

export default () => combineReducers({    
    config,
    ui,
    customer,
    user,
    form
});